<template>
  <div class="column col-12 pb-3">
    <vue-editor 
      height="250"
      :placeholder="$t('job.form.summary.placeholder')"
      v-model="note"
    >
    </vue-editor>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      note: ''
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    'parameters.submitted': function () {
      this.note = ''
    }
  }
}
</script>